const androidRegexp = /Android/i;
const appleRegexp = /iPhone|iPad|iPod/i;

export const detectDevice = (userAgent: string) => {
  if (androidRegexp.test(userAgent)) {
    return 'android';
  }
  if (appleRegexp.test(userAgent)) {
    return 'apple';
  }
  return null;
};
